<template>
  <div id="contact">
    <transition name="fade">
      <div id="toTop" @click="toTop" v-if="searchBarFixed">
        <img id="h_img" src="../../../assets/images/totop.png" alt="">
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'hFixedContact',
  data () {
    return {
      searchBarFixed: ''
    }
  },
  mounted () {
    var _this = this
    window.addEventListener('scroll', _this.handleScroll)
  },
  methods: {
    // 返回顶部
    toTop () {
      const that = this
      // console.log("返回顶部");
      var gotoTop = function () {
        var currentPosition = document.documentElement.scrollTop || document.body.scrollTop
        currentPosition -= 10
        document.documentElement.ontouchstart = function () {
          clearInterval(timer)
          timer = null
          that.searchBarFixed = false
        }
        if (currentPosition > 0) {
          window.scrollTo(0, currentPosition)
        } else {
          window.scrollTo(0, 0)
          clearInterval(timer)
          timer = null
        }
      }
      var timer = setInterval(gotoTop, 1)
    },
    handleScroll () {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop > 10) {
        this.searchBarFixed = true
      } else {
        this.searchBarFixed = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
#toTop {
  width: 1.2rem;
}
#h_img {
  display: block;
  margin-bottom: 0.133rem;
  width: 1rem;
}
#contact {
  position: fixed;
  top: 79%;
  right: 0.25rem;
  cursor: pointer;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/solutions/template/detail-toTop.vue